
      import Date from './date.vue'
      import type { App, Plugin } from 'vue'

      export const DatePlugin: Plugin = {
        install(app: App) {
          app.component('Date', Date)
        },
      }
      export { Date }
      